var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8482 15.8671L11.7173 11.604C12.799 10.3714 13.4637 8.74127 13.4637 6.94749C13.4632 3.11025 10.4495 0 6.73158 0C3.0137 0 0 3.11025 0 6.94749C0 10.7847 3.0137 13.895 6.73158 13.895C8.33796 13.895 9.8113 13.3123 10.9686 12.3435L15.1156 16.6234C15.3176 16.8322 15.6457 16.8322 15.8477 16.6234C16.0503 16.4147 16.0503 16.0758 15.8482 15.8671ZM6.73158 12.8261C3.58585 12.8261 1.03575 10.1941 1.03575 6.94749C1.03575 3.70083 3.58585 1.06891 6.73158 1.06891C9.87734 1.06891 12.4274 3.70083 12.4274 6.94749C12.4274 10.1941 9.87734 12.8261 6.73158 12.8261Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b59068ad51c20f189baa1204b7eb8ec8.svg";
export { ForwardRef as ReactComponent };